import CustomerInfoDisplay from '~/components/CustomerInfoDisplay';
import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';

type CodeDetail = {
  url: string;

  returnToName: string;
  fromAddress: {
    line1: string;
    line2?: string | null | undefined;
    city: string;
    countryCode: string;
    postalCode?: string | null | undefined;
    stateOrProvinceCode?: string | null | undefined;
  };
  carrier: string;
  carrierIconImgUrl: string;
  confirmation: string;
};
export function QrCode<T extends CodeDetail>({ details }: { details: T }) {
  return (
    <figure className="flex w-full flex-col items-center self-center rounded-lg border border-outline sm:flex-row sm:items-stretch">
      <div className="flex basis-1/2 items-center justify-center">
        <img
          alt="QR Code for shipping label"
          className="w-72 p-4"
          src={details.url}
        />
      </div>
      <figcaption className="flex w-full basis-1/2 items-center justify-center rounded-tr-none rounded-br-lg rounded-bl-lg border-t border-outline bg-surface-container-low p-4 sm:rounded-tr-lg sm:rounded-bl-none sm:border-t-0 sm:border-l">
        <span className="sr-only">QR Code for shipping label</span>
        <DescriptionList className="w-full grid-cols-1 justify-start *:py-0 [&>dd]:mb-2 [&>dd]:text-left [&>dt]:text-on-surface-variant">
          <DescriptionListItem
            variant="xs"
            label="Confirmation"
            value={`#${details.confirmation}`}
          />
          <DescriptionListItem
            variant="xs"
            label="Carrier"
            value={
              <span className="flex items-center gap-1">
                <img
                  aria-hidden
                  alt="carrier"
                  className="w-8"
                  src={details.carrierIconImgUrl}
                />
                {details.carrier}
              </span>
            }
          />
          <DescriptionListItem
            variant="xs"
            label="To"
            value={details.returnToName}
          />
          <DescriptionListItem
            variant="xs"
            label="From"
            value={
              <CustomerInfoDisplay
                info={{
                  address: {
                    ...details.fromAddress,
                    line2: details.fromAddress.line2 ?? undefined,
                    postalCode: details.fromAddress.postalCode ?? undefined,
                    stateOrProvinceCode:
                      details.fromAddress.stateOrProvinceCode ?? undefined,
                    phone: undefined,
                  },
                }}
              />
            }
          />
        </DescriptionList>
      </figcaption>
    </figure>
  );
}
